import { faCalendarDay, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import ServiceEvents_Messages from "./ServiceEvents_Messages";

export default function ModalServiceEvents(props) {
    const {popData, setPopData} = props;
    const {show, serviceID, serviceType, customerID} = popData;
    return (
        <Modal show={show} onHide={() => { }} size="lg">
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCalendarDay} size="lg" />&nbsp; رویدادهای سرویس
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setPopData({ show: false })} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
            <ServiceEvents_Messages serviceID={serviceID} serviceType={serviceType} customerID={customerID} />
            </Modal.Body>
        </Modal>
    )
}